var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/images/logo-without-letter-o.png")}}),_c('img',{staticClass:"letter-o",attrs:{"src":require("../assets/images/letter-o.gif")}})])
}]

export { render, staticRenderFns }